import { C } from '../theme/palette';

/**
 * Lien vers la page Abonnement, quand un refus tient à la formule.
 *
 * Le serveur refuse un compte ou un employé au-delà de la capacité de la
 * formule, et son message nomme la formule supérieure. Le dire sans offrir
 * d'y aller laisserait le patron chercher où l'on change de formule ; le
 * lien n'apparaît que pour ce refus-là, jamais pour une autre erreur.
 *
 * @param {object} props propriétés du composant
 * @param {object} [props.erreur] erreur rendue par l'API
 * @param {(route: string) => void} [props.onNav] navigation de l'application
 * @param {boolean} [props.clair] vrai sur un fond sombre
 * @returns {import('react').ReactElement|null} le lien, ou rien
 */
export function LienFormules({ erreur, onNav, clair = false }) {
  if (!erreur?.estLimiteFormule || typeof onNav !== 'function') return null;
  return (
    <button
      onClick={() => onNav('abonnement')}
      style={{
        marginLeft: 8,
        background: clair ? '#fff' : C.purple,
        color: clair ? C.red : '#fff',
        border: 'none',
        borderRadius: 6,
        padding: '2px 8px',
        fontSize: 11,
        fontWeight: 800,
        cursor: 'pointer',
      }}
    >
      ⭐ Voir les formules
    </button>
  );
}
